import { Checkbox } from '@mui/material';
import React from 'react'
import CouponConfigurableLabel from '../CouponConfigurableLabel';
import {useSelector} from 'react-redux';
import {updateIsOverAndAbove,updateSkipMarketSelection} from '../../../../stateManagement/actions/manageCouponActions'
import {showskipMarketDetails} from './MarketDetails/configData';

/**
 * This component is a general component which is a radio selector
 * Options : List of option of radio selector fileds 
 * direction : direction of options
 * selectedValue : selected option
 * handleChange : this function gets executed when there any selection is done in radio field
 * @param props 
 * @returns 
 */

function OverAndAboveCheckBox(props:any):any {
    let isOverAndAbove:boolean = useSelector((state: any) => state?.manageCoupons?.data?.isOverAndAbove);
    const {options , selectedValue , handleChange, direction="row"} = props;
    const handleCheckBoxChange=()=> {
        if(isOverAndAbove){
          updateIsOverAndAbove(false);
          updateSkipMarketSelection(false);        }
        else{
            updateIsOverAndAbove(true);
            showskipMarketDetails()?updateSkipMarketSelection(true):updateSkipMarketSelection(false);
        }
        
    }

  return (
    //   <div className="Coupon-radio-selector-wrapper">
          <div style={{"marginTop":'1rem'}}>
                <CouponConfigurableLabel text={'IS_OVER_AND_ABOVE'} style={{ color: 'inherit', cursor: 'default' ,fontWeight:'500'}} />
                <Checkbox checked={isOverAndAbove} onChange={handleCheckBoxChange} className='select-checkbox'/>
            </div> 
    //   </div>
  )
}

export default OverAndAboveCheckBox